"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlRedirect = exports.ssoTokenByCode = void 0;

var _httpRequest = _interopRequireDefault(require("../httpRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 通过code获取ssoToken
 * @author pimingyue
 * @date 2022/06/21
 */
var AUTH_SERVER = 'https://ac.igetcool.com';

var ssoTokenByCode = function ssoTokenByCode(data) {
  var url = AUTH_SERVER + '/api/auth/token';
  return _httpRequest["default"].request(url, data, {
    method: 'get',
    forceAjax: 'true',
    outUrl: url
  });
}; // 通过code获取token之后重定向回原链接去，去掉原链接中的code


exports.ssoTokenByCode = ssoTokenByCode;

var urlRedirect = function urlRedirect() {
  var options = {};

  if (location.search.split('?')[1]) {
    var str = location.search.split('?')[1].split('&');

    for (var i = 0; i < str.length; i++) {
      options[str[i].split('=')[0]] = str[i].split('=')[1];
    }
  }

  delete options.code; // 若对象中的属性除了code没有别的属性则直接

  var url = '';

  if (Object.keys(options).length == 0) {
    url = location.href.split('?')[0];
  } else {
    url = location.href.split('?')[0] + '?';

    for (var k in options) {
      url += k + '=' + options[k] + '&';
    }
  }

  window.location.replace(url);
  return;
};

exports.urlRedirect = urlRedirect;